/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    TimeFormats,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';
import TableItem from '@appblocks/codegeneration/SettingsConfigurations/TableItem';
import Cgg from '.';


export const getCodeBlocks = (feature: Cgg): CodeBlock[] => {
    let blocks: CodeBlock[] = [];
    const generalFeature = feature.project.getFeature('general');
    let timeFormat = generalFeature.getSettingValue('TIME_FORMAT');

    if (timeFormat === TimeFormats.twelveHour) {
        timeFormat = 'hh:mm tt';
    } else {
        timeFormat = 'HH:mm';
    }

    const SCHEDULES = feature.getSettingValue('SCHEDULES');
    if (SCHEDULES.length === 0) {
        return blocks;
    }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare crons as crontab(CRON_MAX_SCHEDULES)
declare datetime_timer_offset as dword
declare sub cron_check_tabs()
declare sub callback_cron_expired(index as byte)`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim crons as crontab(CRON_MAX_SCHEDULES)
dim datetime_timer_offset as dword=0`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
sub callback_cron_expired(index as byte)
    '****callback_cron_expired****'
end sub`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
sub cron_check_tabs()
    if CRON_MAX_SCHEDULES=0 then
        exit sub
    end if
    dim i as byte=0
    for i=0 to CRON_MAX_SCHEDULES-1
        if crons(i).next_timestamp=0 then
            dim timestamp as dword=datetime_next_cron(crons(i))
            dim dstr as string=datetime_timestamp_to_string(timestamp,"YYYY-MM-DD hh:mm tt")
            sys.debugprint("CRON> next schedule at " + str(i) + " to " + dstr)
            crons(i).next_timestamp=timestamp
        else
            if sys.timercountms/1000 + datetime_timer_offset > crons(i).next_timestamp then
                crons(i).next_timestamp=0
                callback_cron_expired(i)
            end if
        end if
    next i
end sub`,
    });

    blocks.push({
        location: 'callback_sntp_ok',
        blockType: BlockType.CODE,
        template: `
    datetime_timer_offset=datetime_current_timestamp() - sys.timercountms/1000
    'set crontabs
    if CRON_MAX_SCHEDULES>0 then
        dim i as byte
        for i=0 to CRON_MAX_SCHEDULES-1
            crons(i).next_timestamp=0
        next i
    end if
    `,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
    cron_check_tabs()`,
    });

    let callbackCode = '';

    for (let i = 0; i < SCHEDULES.length; i += 1) {
        const PATTERN = SCHEDULES[i].getSettingValue('PATTERN');
        const NAME = SCHEDULES[i].getSettingValue('NAME');
        const parts = PATTERN.split(' ');
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    crons(${i}).next_timestamp=0 'initialize to not set
    crons(${i}).minute=${parts[0] === '*' ? '255' : parts[0]}
    crons(${i}).hour=${parts[1] === '*' ? '255' : parts[1]}
    crons(${i}).day=${parts[2] === '*' ? '255' : parts[2]}
    crons(${i}).month=${parts[3] === '*' ? '255' : parts[3]}
    crons(${i}).day_of_week=${parts[4] === '*' ? '255' : `"${parts[4]}"`}
    crons(${i}).astro=${(parts.length < 6 || parts[5] === '*') ? '255' : `"${parts[5]}"`}`,
        });

        callbackCode += `
            case ${i}:
                sys.debugprint("CRON> ${NAME} triggered")
                cron_expired_${NAME}()
            `;
        blocks = blocks.concat(SCHEDULES[i].getCodeBlocks());
    }
    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    datetime_timer_offset=datetime_current_timestamp() - sys.timercountms/1000`,
    });

    blocks.push({
        location: 'callback_cron_expired',
        blockType: BlockType.CODE,
        template: `
    select case index
    ${callbackCode}
        case else:
    end select`,
    });

    return blocks;
};
